import React, { useEffect, useRef } from "react";
import headerCSS from "./header.module.css";

import session from "../../store/session"
import { useAppSelector, useAppDispatch } from "../../store/hook";
import { Modal, Layout, Menu, Image, Checkbox, Form, Input, FormInstance, message } from "antd";
import { useLocation, useHistory } from "react-router-dom";
import { login } from "../../api/login";
import { logout } from "../../store/user";
import jwt, { JwtPayload } from "jsonwebtoken"
import { registryAction } from "../../api/account";
import { useImperativeHandle } from "react";
import Avatar from "antd/lib/avatar/avatar";
import { useTranslation } from 'react-i18next';
import { t } from "i18next";
import i18n from "../../i18n";
const { Header } = Layout;

export interface IWebHeader {
  theme: "light" | "dark";
  className?: string;
}



const colors = [
  "magenta",
  "red",
  "volcano",
  "orange",
  "gold",
  "lime",
  "green",
  "cyan",
  "blue",
  "geekblue",
  "purple",
];
export interface headerRef {
  registry: () => void;
}
export const WebHeader: React.ForwardRefRenderFunction<headerRef, IWebHeader> = (prop, ref) => {
  const [form] = Form.useForm();
  const { theme } = prop;
  const location = useLocation();
  const history = useHistory();
  //const key = useAppSelector((state) => state.user.key);
  const dispatch = useAppDispatch();
  const status = useAppSelector((state) => state.user.user);
  const name: string = useAppSelector(
    (state) => (jwt.decode(state.user.key) as JwtPayload)?.name || "匿名"
  );
  const id: number = useAppSelector(
    (state) => (jwt.decode(state.user.key) as JwtPayload)?.id || -1
  );
  const [visible, setVisible] = React.useState(false);
  const [confirmLoading,] = React.useState(false);

  const useResetFormOnCloseModal = ({ form, visible }: { form: FormInstance; visible: boolean }) => {
    const prevVisibleRef = useRef<boolean>();
    useEffect(() => {
      prevVisibleRef.current = visible;
    }, [visible]);
    const prevVisible = prevVisibleRef.current;

    useEffect(() => {
      if (!visible && prevVisible) {
        form.resetFields();
      }
    }, [visible, prevVisible, form]);
  };

  const showModal = () => {
    if (status === "guest") {
      form.resetFields();
      setVisible(true);
    }
  };


  useImperativeHandle(ref, () => ({
    registry: () => {
      if (status === "guest") {
        showModal();
      } else {
        message.info(t("您已登录，快去报名吧!"));
      }
    }
  }))

  const handleCancel = () => {
    console.log('Clicked cancel button');
    setVisible(false);
  };

  const onFinish = (values: any) => {
    console.log('Success:', values);
    registryAction({ ...values, reCaptcha: "none" }).then(data => {
      message.success(t("注册成功"));
      setVisible(false);
      //console.log(data);
    }).catch(err => {
      message.error(t("注册失败")+err);
      setVisible(false);
      console.log(err);
    });
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };
  useResetFormOnCloseModal({
    form,
    visible,
  });

  const onOk = () => {
    form.submit();
  };

  const exit = () => {
    session.key = "";
    dispatch(logout());
    message.success(t("登出成功"))
    history.push("/");
  };
  return (
    <Header
      className={`${headerCSS.navHeader} ${theme === "dark" ? headerCSS.navDark : headerCSS.navLight
        } ${prop.className ? prop.className : ""}`}
    >
      <meta name="viewport" content="width=1200px" />
      <div className={headerCSS.navHeaderContainer}>
        <Image
          src={`https://naic.pcl.ac.cn/head-1${theme === "dark" ? "-light" : ""
            }.svg`}
          preview={false}
          height={48}
          className={headerCSS.logo}
        ></Image>
        <Menu className={headerCSS.navMenu} theme={theme} mode="horizontal">
          <Menu.Item
            key="language"
            onClick={() => {
              if(i18n.language=="zh")
                i18n.changeLanguage("en");
              else
                i18n.changeLanguage("zh");
            }}
          >
            {t("切换语言")}
          </Menu.Item>
          <Menu.Item
            key="mainpage"
            onClick={() => {
              history.push("/");
            }}
          >
            {t("首页")}
          </Menu.Item>
          <Menu.Item
            key="contest"
            onClick={() => {
              // history.push("/landingpage/2021");
              // window.location.href = "https://naic.pcl.ac.cn/landingpage/2023/index.html";
              window.location.href = "https://app-kyxt.pcl.ac.cn/competitions/group/v3atucf9";
            }}
          >
            {t("竞赛")}
          </Menu.Item>
          <Menu.Item
            key="OpenI"
            onClick={() => {
              // history.push("/landingpage/2021");
              window.location.href = "https://openi.org.cn/";
            }}
          >
            {t("OpenI实训项目")}
          </Menu.Item>

          {status === "guest" ? (
            <>
              <Menu.Item
                key="registry"
                onClick={() => window.open('https://openi.pcl.ac.cn/login/oauth/authorize?client_id=5109524b-c405-4809-8bdf-dc4ceb713064&redirect_uri=https://app-kyxt.pcl.ac.cn/auth/openi/login&response_type=code&state=STATE', '_blank')}
              >
                {t("注册")}
              </Menu.Item><Menu.Item
                key="login"
                onClick={() => window.open('https://openi.pcl.ac.cn/login/oauth/authorize?client_id=5109524b-c405-4809-8bdf-dc4ceb713064&redirect_uri=https://app-kyxt.pcl.ac.cn/auth/openi/login&response_type=code&state=STATE', '_blank')}
              >
                {t("登录")}
              </Menu.Item>
            </>
          ) : status === "user" ? (
            <Menu.SubMenu key="user" title={<><Avatar
              src={`https://avatar-1256691515.cos.ap-guangzhou.myqcloud.com/avatar-${id}.png`}
              style={{
                backgroundColor: colors[(id || 0) % 11],
                fontSize: "20px",
                marginRight: "5px"
              }}
            >
              {name[0]}
            </Avatar>{name}</>}>
              <Menu.Item key="user:info"
                onClick={() => {
                  history.push("/account");
                }}>{t("个人信息")}</Menu.Item>
              <Menu.Item key="user:logout" onClick={exit}>
                {t("登出")}
              </Menu.Item>
            </Menu.SubMenu>
          ) : status === "admin" ? (
            <Menu.Item key="admin">{t("管理员")}</Menu.Item>
          ) : (
            <></>
          )}
        </Menu>

        <Modal
          title={t("OpenI用户注册")}
          visible={visible}
          onOk={onOk}
          confirmLoading={confirmLoading}
          onCancel={handleCancel}
          destroyOnClose
          maskClosable={false}
          keyboard={false}
        >
          <Form
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Form.Item
              label={t("用户名")}
              name="name"
              rules={[{ required: true, message: '请输入您的用户名' }, { pattern: /^[a-zA-Z0-9_-]+$/, message: '用户名应为英文字母、数字和下划线构成' }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={t("邮箱")}
              name="email"
              rules={[{ required: true, message: '请输入您的邮箱' }, { pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, message: '邮箱格式不正常' }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label={t("密码")}
              name="password"
              rules={[{ required: true, message: '请输入您的密码' }, { pattern: /^(?![A-Za-z\\W]+$)(?![0-9A-Z\\W]+$)[0-9A-Za-z\\W]{6,255}$/, message: "密码必须为6-255位并同时具有小写字母与数字" }]}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item
              label={t("重复密码")}
              name="repassword"
              rules={[{ required: true, message: '请重复输入您的密码' }, ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('重复的密码不匹配'));
                },
              }),]}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item name="read" valuePropName="checked" wrapperCol={{ offset: 8, span: 16 }}
              rules={[{
                validator: (_, value) => new Promise((resolve, reject) => {
                  if (value) return resolve(null);
                  else return reject("请阅读用户须知及协议并承诺遵守");
                })
              }]}>
              <Checkbox >{t("我已经阅读")}<a href="javascript:window.open('/readme.txt','用户须知','width=400,height=750')">用户须知及协议</a>{t("并承诺遵守")}</Checkbox>
            </Form.Item>

          </Form>
        </Modal>
      </div>
    </Header>
  );
};

export const WebRefHeader = React.forwardRef(WebHeader);
export default WebRefHeader;
